import i18next from 'i18next';
import { arrayOf, bool, func, number, shape } from 'prop-types';
import React from 'react';

import ButtonLoading from '~app/components/ButtonLoading';
import { field } from '~propTypes/field';
import Error from '~app/components/Error';
import { hasBeenSubmitted, hasErrorsAndIsTouched } from '~utils/formik';
import { useKind } from '~app/hooks/useKind';
import { IDENTITY_BANNERS } from '~constants/banners';
import Banner from '~app/components/Banner';

import styles from './styles.module.scss';
import LaborFields from './LaborFields';

const LaborForm = ({
  values,
  onChange,
  errors,
  touched,
  setFieldValue,
  setFieldTouched,
  setLaborSituation,
  buttonLoading,
  additionalFields,
  submitCount
}) => {
  const kind = useKind();
  const header = () => <span className={styles.sectionTitle}>{i18next.t('LaborInformation:title')}</span>;

  return (
    <div className={styles.formContainer}>
      <Banner src={IDENTITY_BANNERS[kind]} />
      <div className={styles.container}>
        <LaborFields
          values={values}
          onChange={onChange}
          errors={errors}
          setFieldTouched={setFieldTouched}
          touched={touched}
          setFieldValue={setFieldValue}
          setLaborSituation={setLaborSituation}
          header={header}
          additionalFields={additionalFields}
          formClassName={styles.formFieldsContainer}
        />
        <div className={styles.messageContainer}>
          <Error
            error={i18next.t('LaborInformation:hasErrors')}
            show={hasBeenSubmitted(submitCount) && hasErrorsAndIsTouched(errors, touched)}
            errorClassName={styles.errorMessage}
          />
          {values.laborSituation && (
            <span className={styles.message}>
              <b>{i18next.t(`LaborInformationMessageTitle:${values.laborSituation}`)}</b>
              {i18next.t(`LaborInformationMessage:${values.laborSituation}`)}
            </span>
          )}
          <ButtonLoading type="submit" primary loading={buttonLoading}>
            {i18next.t('LaborInformation:button')}
          </ButtonLoading>
        </div>
      </div>
    </div>
  );
};

LaborForm.propTypes = {
  additionalFields: arrayOf(field),
  buttonLoading: bool,
  errors: shape,
  setFieldTouched: func,
  setFieldValue: func,
  setLaborSituation: func,
  submitCount: number,
  touched: shape,
  values: shape,
  onChange: func
};

export default LaborForm;
